<div class="sidebar-menu-content" style="min-height: 649px">
  <div
    class="col-lg-8 content-wrapper mt-4 me-3"
    style="width: 100%; margin-left: 5px"
  >
    <div class="col-lg-12 pt-5 pe-5">
      <div class="row">
        <div class="col-lg-12">
          <div>
            <div class="d-inline-block">
              <span class="task-header"
                >Time Card
                <span class="f-12"
                  >({{ userSelectedEvent?.jobNameWithOutCode }})</span
                ></span
              >
            </div>
            <div class="float-end mx-3 position-relative">
              <div class="d-inline-block my-auto" *ngIf="!readOnlyApp">
                <label class="font-label-major float-start"
                  >Multiple Selection Mode</label
                >
                <div class="form-check form-switch d-inline-block my-auto ms-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    [(ngModel)]="multiMode"
                    (click)="reset()"
                    [disabled]="readOnlyApp"
                  />
                </div>
              </div>
              <div class="input-group-prepend d-inline-block ms-2">
                <span class="input-group-text">
                  <img
                    [src]="constants.staticImages.icons.calender"
                    alt="image hear"
                  />
                  <input
                    type="text"
                    placeholder=""
                    #date
                    class="form-control date-picker"
                    bsDatepicker
                    [bsConfig]="constants.bsconfig"
                    [(bsValue)]="selectedDate"
                    disabled
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-3 multi-select" *ngIf="multiMode">
          <div class="multi-select mx-auto">
            <div class="float-start py-2">
              <span class="align-selected-no ms-3"
                >{{ selectedInput }} Selected</span
              >
            </div>
            <div class="float-end py-2">
              <button
                class="btn btn-outline-primary multi-select-btn"
                (click)="reset()"
                [disabled]="readOnlyApp"
              >
                Deselect All
              </button>
              <button
                class="btn btn-primary ms-2 multi-select-btn"
                [disabled]="
                  !(this.employeeData.length || this.equipmentData.length)
                "
                (click)="openCalculator(logHoursInputTemplate)"
              >
                Add Value
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 row time-table">
        <p-table
          [value]="products"
          dataKey="id"
          styleClass="time-card"
          responsiveLayout="scroll"
          [scrollable]="true"
          scrollDirection="horizontal"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="py-2 vertical-set fix-width-mesure" pFrozenColumn>
                <ng-container *ngIf="!readOnlyApp">
                  <a
                    *ngFor="let link of timecardConfig.links"
                    class="ms-1 mb-4 text-decoration-none d-block fast-sidebar-button"
                    (click)="link.onClick()"
                  >
                    <img
                      [src]="constants.staticImages.plusIcon"
                      alt="add icon"
                      class="me-2"
                    />{{ link.title }}</a
                  >
                </ng-container>
              </th>
              <th
                class="table-column-header fix-text-dark table-total-hours text-center fix-font-wight fix-th-border fix-total-hours"
                pFrozenColumn
              >
                Total Hours
              </th>
              <th
                class="table-column-header fix-th-border col-phase-width vertical-set"
                *ngFor="let phaseList of phaseDetailsArray"
                [popover]="popTemplate"
                (mouseenter)="toolTipText = phaseList.itemDescription || ''"
                [outsideClick]="true"
                triggers="mouseenter:mouseleave"
                [ngClass]="{ 'is-tm': phaseList?.isTANDM }"
              >
                <div class="large-screen-display">
                  <span class="description-font"
                    >{{ phaseList?.description }} </span
                  ><br />
                  <span class="highlighted-color">{{
                    phaseList?.phaseID
                  }}</span>
                  <p
                    *ngIf="phaseList?.isTANDM && timecardConfig.enableTandM"
                    class="t-m-tag mt-1"
                  >
                    <span class="px-2">T&M</span>
                  </p>
                  <div
                    *ngIf="
                      !phaseList?.isTAndMPhaseAdded &&
                      timecardConfig.enableTandM
                    "
                    class="d-flex flex-nowrap justify-content-start"
                  >
                    <p class="t-m-label mt-1" *ngIf="!readOnlyApp">T & M :</p>
                    <div class="form-check form-switch ms-2 mt-1">
                      <input
                        *ngIf="!readOnlyApp"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        [ngModel]="phaseList.isTANDM"
                        (ngModelChange)="
                          unSavedSingleTAndMSwitch(
                            phaseList.phaseID,
                            phaseList.isTANDM
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="medium-screen-display"
                  [popover]="popTemplate"
                  (click)="toolTipText = phaseList.itemDescription || ''"
                  [outsideClick]="true"
                  triggers="click"
                >
                  <span class="description-font">{{
                    phaseList?.description
                  }}</span
                  ><br />
                  <span class="highlighted-color">{{
                    phaseList?.phaseID
                  }}</span>
                  <p
                    *ngIf="phaseList?.isTANDM && timecardConfig.enableTandM"
                    class="t-m-tag mx-auto mt-1"
                  >
                    <span class="px-2">T&M</span>
                  </p>
                  <div
                    *ngIf="
                      !phaseList?.isTAndMPhaseAdded &&
                      timecardConfig.enableTandM
                    "
                    class="d-flex flex-nowrap justify-content-start mt-1"
                  >
                    <p class="t-m-label" *ngIf="!readOnlyApp">T & M :</p>
                    <div class="form-check form-switch ms-2">
                      <input
                        *ngIf="!readOnlyApp"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        [ngModel]="phaseList.isTANDM"
                        (ngModelChange)="
                          unSavedSingleTAndMSwitch(
                            phaseList.phaseID,
                            phaseList.isTANDM
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product>
            <ng-container>
              <tr
                *ngFor="let employee of mergedArrayEmployee | keyvalue"
                class="text-center"
              >
                <td class="table-column" pFrozenColumn>
                  <ng-container
                    *ngFor="let crueDetails of getEmployeeName(employee.key)"
                  >
                    <span
                      class="table-cell pe-auto pointer"
                      (click)="openPerDiemSidebar(perDiem, crueDetails)"
                      [ngClass]="{ 'read-only': readOnlyApp }"
                    >
                      {{ crueDetails?.fullName }}
                    </span>
                    <span
                      class="ms-2"
                      *ngIf="crueDetails.isLoggedHoursOtherJob"
                      title="Hours logged"
                      ><img
                        [src]="constants.staticImages.loggedHours"
                        alt="Hours logged"
                    /></span>
                    <br />
                    <span
                      [ngStyle]="{ color: crueDetails?.colorCode }"
                      class="jobtitle-color pt-1 pb-1"
                      [title]="crueDetails?.jobTitle"
                      >{{ crueDetails?.jobTitle }}-{{
                        crueDetails?.positionCode
                      }}</span
                    >
                  </ng-container>
                </td>
                <td class="table-total-hours text-center" pFrozenColumn>
                  <span class="fix-text-dark">{{
                    getTotalHours(employee.key)
                  }}</span>
                </td>
                <td
                  pEditableColumn
                  *ngFor="
                    let finalData of getEmployeePhaseList(employee.value);
                    let index = index
                  "
                  class="table-editable-cell"
                  [ngClass]="{ 'is-tm': finalData?.isTANDM }"
                >
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <button
                        class="editable-form text-center btn-background"
                        (click)="
                          openSideBar(
                            logHoursInputTemplate,
                            finalData,
                            'Employee'
                          );
                          !finalData.isSelected
                            ? (finalData.isSelected = true)
                            : (finalData.isSelected = false)
                        "
                        [ngClass]="{
                          selected: findUpdateHours(
                            finalData.employeeId,
                            finalData.phaseId,
                            employeeData,
                            finalData.isTANDM
                          ),
                          'read-only': readOnlyApp
                        }"
                      >
                        {{ finalData.loggedHours }}
                      </button>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <button
                        class="editable-form text-center btn-background"
                        (click)="
                          openSideBar(
                            logHoursInputTemplate,
                            finalData,
                            'Employee'
                          );
                          !finalData.isSelected
                            ? (finalData.isSelected = true)
                            : (finalData.isSelected = false)
                        "
                        [ngClass]="{
                          selected: findUpdateHours(
                            finalData.employeeId,
                            finalData.phaseId,
                            employeeData,
                            finalData.isTANDM
                          ),
                          'read-only': readOnlyApp
                        }"
                      >
                        {{ finalData.loggedHours }}
                      </button>
                    </ng-template>
                  </p-cellEditor>
                </td>
              </tr>
              <tr
                *ngFor="let employee of finalEquipmentList | keyvalue"
                class="text-center"
              >
                <td class="table-column border-emp" pFrozenColumn>
                  <ng-container
                    *ngFor="let crueDetails of getEquipmentName(employee.key)"
                  >
                    <span class="table-cell pe-auto">
                      {{ crueDetails.description }}
                    </span>
                    <span
                      class="ms-2"
                      *ngIf="crueDetails?.equipmentId"
                      title="equipment"
                    >
                      <img
                        [src]="constants.staticImages.truckImageSvg"
                        alt="Hours logged "
                    /></span>
                    <p>{{ crueDetails.category }}</p>
                  </ng-container>
                </td>
                <td class="table-total-hours text-center" pFrozenColumn>
                  <span class="fix-text-dark">{{
                    getEquipmentTotalHours(employee.key)
                  }}</span>
                </td>
                <td
                  pEditableColumn
                  *ngFor="let finalData of getEmployeePhaseList(employee.value)"
                  class="table-editable-cell"
                  [ngClass]="{ 'is-tm': finalData?.isTANDM }"
                >
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <button
                        class="editable-form text-center btn-background"
                        (click)="
                          openSideBar(
                            logHoursInputTemplate,
                            finalData,
                            'Equipment'
                          );
                          !finalData.isSelected
                            ? (finalData.isSelected = true)
                            : (finalData.isSelected = false)
                        "
                        [ngClass]="{
                          selected: findUpdateEquipmentHours(
                            finalData.equipmentId,
                            finalData.phaseId,
                            equipmentData,
                            finalData.isTANDM
                          ),
                          'read-only': readOnlyApp
                        }"
                      >
                        {{ finalData.loggedHours }}
                      </button>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <button
                        class="editable-form text-center btn-background"
                        (click)="
                          openSideBar(
                            logHoursInputTemplate,
                            finalData,
                            'Equipment'
                          );
                          !finalData.isSelected
                            ? (finalData.isSelected = true)
                            : (finalData.isSelected = false)
                        "
                        [ngClass]="{
                          selected: findUpdateEquipmentHours(
                            finalData.equipmentId,
                            finalData.phaseId,
                            equipmentData,
                            finalData.isTANDM
                          ),
                          'read-only': readOnlyApp
                        }"
                      >
                        {{ finalData.loggedHours }}
                      </button>
                    </ng-template>
                  </p-cellEditor>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </div>

      <div class="row mt-5 custom-actions" *ngIf="!readOnlyApp">
        <div class="me-5">
          <!-- <button class="btn btn-primary" (click)="saveTableViewChanges()">Save & Exit</button> -->
          <button class="btn btn-primary" (click)="saveTableOnDestroy()">
            Update
          </button>
          <button
            class="btn btn-primary ms-2"
            (click)="saveTableViewChanges(1)"
          >
            Update & Exit
          </button>
          <!-- <button class="btn btn-outline-primary mx-2 arrow-icon-hover" *ngIf="timecardConfig.enableNextBtn" (click)="saveTableViewChanges(1)" [appImageIconSrc]="constants.staticImages.arrowButton" [hoverImgSrc]="constants.staticImages.arrowWhite" [ngClass]="{ 'read-only': readOnlyApp }">
      <span>Next</span>
      <span class="ms-1 arrow-icon"></span>
    </button> -->
        </div>
      </div>

      <!-- <div class="row mt-5 custom-actions me-4" *ngIf="readOnlyApp">
                <button class="btn btn-outline-primary mx-2 arrow-icon-hover" *ngIf="timecardConfig.enableNextBtn" (click)="goToReview();" [appImageIconSrc]="constants.staticImages.arrowButton" [hoverImgSrc]="constants.staticImages.arrowWhite">
  <span>Next</span>
  <span class="ms-1 arrow-icon"></span>
</button>
            </div> -->

      <ng-template #addEmployeeSidebar>
        <app-sidebar [modalRef]="employeeModalRef">
          <h5 modalHeader class="custom-modal-header">Add Crew to time card</h5>
          <app-add-employee
            modalBody
            [selectedEmployee]="crewDetails"
            (onClose)="closeSidebar()"
          ></app-add-employee>
        </app-sidebar>
      </ng-template>

      <ng-template #addPhaseSidebar>
        <app-sidebar [modalRef]="phaseModalRef" (onModalClose)="closeSidebar()">
          <h5 modalHeader class="custom-modal-header">Add Phases</h5>
          <app-add-phase
            modalBody
            [jobScheduleId]="selectedJobScheduleId"
            [jobScheduleDate]="selectedDate"
            [enableTMSwitching]="isAddPhaseTandMEnabled"
            (onModalClose)="closeSidebar()"
            [isDeliveries]="false"
            [isConcrete]="false"
          ></app-add-phase>
        </app-sidebar>
      </ng-template>

      <ng-template #addEquipment>
        <app-sidebar [modalRef]="equipmentModalRef">
          <h5 modalHeader class="custom-modal-header">Add Equipment</h5>
          <app-add-equipment
            modalBody
            [origin]="'TimeCard'"
            [jobScheduleId]="selectedJobScheduleId"
            [jobScheduleDate]="selectedDate"
            [rightSideEquipmentList]="_addEquipment"
            (onClose)="closeSidebar()"
          >
          </app-add-equipment>
        </app-sidebar>
      </ng-template>

      <ng-template #perDiem>
        <app-sidebar [modalRef]="perDiemModalRef">
          <h5 modalHeader class="custom-modal-header">Details</h5>
          <app-per-diem-sidebar
            modalBody
            [currentList]="passPerDiem"
            (onClose)="closeSidebar(1)"
          ></app-per-diem-sidebar>
        </app-sidebar>
      </ng-template>

      <ng-template #popTemplate>
        <div class="card">
          <div class="card-body py-2">
            <img
              class="tooltip-icon"
              [src]="constants.staticImages.infoIcon"
              alt="info"
            />
            <span class="tooltip-text ms-1">{{ toolTipText }}</span>
          </div>
        </div>
      </ng-template>

      <ng-template #logHoursInputTemplate>
        <app-sidebar [modalRef]="inputModalRef">
          <h5 modalHeader class="custom-modal-header">Logged Hours</h5>
          <app-custom-number-input
            modalBody
            (customChanged)="closeCalculator($event)"
          ></app-custom-number-input>
        </app-sidebar>
      </ng-template>
    </div>
  </div>
</div>
